import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Breadcrumb = ({ pathname }) => {

  let pathNameArr = String(pathname).split("/");
  console.log("pathname array", pathNameArr)
  let name = pathNameArr[1];
  const location = useLocation()

  const newParams = new URLSearchParams(location.search);

  return (
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-9">
        <h2 className="text-capitalize">{name ? name.replace("-", " ") : 'Profile'}</h2>
        <ol class="breadcrumb text-capitalize">
          {/* <Link to={location.pathname}>{pathname}</Link> */}
          {/* <Link to={newParams.get('screen') == '/users/1' ? 'users' : newParams.get('screen') == 'creators' ? '/creators/1' : '#'}></Link> */}
          {/* <li class="breadcrumb-item">
            <a href="index.html">Home</a>
          </li>
          <li class="breadcrumb-item">{from}</li>
          <li class="breadcrumb-item active">
            <strong> Search Page</strong>
          </li> */}
        </ol>
      </div>
    </div>
  );
};

export default Breadcrumb;
